export default () => import(/* webpackChunkName: 'coffee/wechat-community/wawa-coupon' */ './WawaCoupon');